<template>
  <div class="event-card-list" :class="{ row: row }">
    <div v-if="button" class="button-card-wrap">
      <slot />
    </div>
    <LvEventCard
      v-for="(event_e, event_k) in eventList"
      bold
      :from="from"
      :key="event_k"
      :id="event_e.id"
      :alertId="alertId"
      :type="event_e.type"
      :titleSize="event_e.titleSize !== undefined ? event_e.titleSize : 1"
      :versionId="event_e.versionId"
      :customQuery="event_e.customQuery"
      :name="event_e.name"
      :date="event_e.date"
      :customClickEvent="event_e.customClickEvent"
    />
  </div>
</template>
<script>
export default {
  name: 'EventCardList',
  props: {
    eventList: {
      type: Array,
      default() {
        return [];
      },
    },
    button: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Boolean,
      default: false,
    },
    from: {
      type: String,
      default: '',
    },
    alertId: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/event-card-list';
</style>
